// Price rendering + revenue math for openings.
//
// Openings created before Feb 2026 stored `price` as a JS number (e.g. 45).
// Openings created after Feb 2026 store `price` as free text ("From $50",
// "$45 – $80", "Ask on the day") so businesses can express ranges and
// "from" pricing on the map. Every consumer surface must handle both.

/**
 * Render an opening's price for display in the UI.
 *
 * @param {string | number | null | undefined} raw
 * @returns {string} Human-readable price, e.g. "A$45", "From $50", "—"
 */
export function displayPrice(raw) {
  if (raw == null || raw === "") return "—";
  if (typeof raw === "number") return `A$${raw}`;
  const s = String(raw).trim();
  return s || "—";
}

/**
 * Parse a free-text or numeric price into a number for revenue math.
 * Returns 0 if no digits are found. "From $50" → 50, "$45 – $80" → 45.
 *
 * @param {string | number | null | undefined} raw
 * @returns {number}
 */
export function priceToNumber(raw) {
  if (raw == null || raw === "") return 0;
  if (typeof raw === "number") return raw;
  const m = String(raw).match(/\d+(?:\.\d+)?/);
  return m ? Number(m[0]) : 0;
}
